import React, { useState } from "react";
import { getPathParams } from "../../../../../utilities";
import styles from "./styles.module.scss";
import { DeleteIcon } from "../../../../../../../../../assets/Icons/DeleteIcon";
import { usePatientDocumentDeleteMutation } from "../../../../../../../../../api/patientDocuments/usePatientDocumentDeleteMutation";
import { uiNotification } from "../../../../../../../../../services/UINotificationService";
import { CircularProgress } from "../../../../../../../../../shared/CircularProgress/CircularProgress";
import { useAppTranslation } from "../../../../../../../../../i18n/useAppTranslation";
import { ConfirmModal } from "../../../../../../../../../boxes/ConfirmModal/ConfirmModal";
import { extractApiError } from "../../../../../../../../../utilities/api";

export function Delete({ id }) {
  var { patientId } = getPathParams();
  var { 0: isConfirmOpen, 1: setIsConfirmOpen } = useState(false);
  var { tClients: t } = useAppTranslation.Clients();

  var mutation = usePatientDocumentDeleteMutation({
    onSuccess: () => {
      uiNotification.success(t("documents.success.delete_one"));
    },
    onError: (res) => {
      var message = extractApiError(res);
      uiNotification.error(
        t([`documents.error.${message}`, "documents.error.delete_one"]),
      );
    },
  });

  return (
    <>
      <button
        className={styles.root}
        disabled={mutation.isLoading}
        onClick={() => setIsConfirmOpen(true)}
      >
        {mutation.isLoading ? (
          <CircularProgress color="red" size="tiny" />
        ) : (
          <DeleteIcon width="17px" />
        )}
      </button>
      {isConfirmOpen && (
        <ConfirmModal
          isOpen
          onClose={() => setIsConfirmOpen(false)}
          onCancel={() => setIsConfirmOpen(false)}
          onConfirm={() => {
            setIsConfirmOpen(false);
            mutation.mutate({ id, patientId });
          }}
        >
          {t("documents.confirm.delete_one")}
        </ConfirmModal>
      )}
    </>
  );
}
